module.exports = __webpack_public_path__ + "img/zhys_zhTc.5e572391.png";